import VersionPanel from './VersionPanel';

export default VersionPanel;
